var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Trade or View your Portfolio")]),_vm._v(" "),_c('h6',[_vm._v("You may save & Load your Data")]),_vm._v(" "),_c('h6',[_vm._v("Click on 'End Day' to begin a New Day !")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',[_vm._v("Your Funds: "+_vm._s(_vm._f("currency")(_vm.funds)))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ec664d3","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 29
// module chunks = 0